module.exports = __webpack_public_path__ + "share-tip.62738ecc.png";